import { create } from 'zustand';

const useSidebarStore = create((set) => ({
  collapsed: false,
  setCollapsed: (collapsed) => set({ collapsed }),
  toggle: () => set((state) => ({ collapsed: !state.collapsed })),
}));

export default useSidebarStore;
